export interface AdsLibraryApiPathParams {
  network?: string;
  region?: string;
}

export const parseAdsLibraryApiPath = (
  resource: string,
  { network = 'facebook', region = 'eu' }: AdsLibraryApiPathParams = {}
): string => `/${network}_ads_library/${region}/${resource}`;
